import { Typography } from "@digital-services/ui";

import NoResultsIcon from "@icons/no_results.svg?react";

interface Props {
  message: string;
}

export function NoResultsWithIcon(props: Readonly<Props>) {
  return (
    <div
      className="flex flex-col items-center justify-center space-y-2 bg-white py-4 text-center"
      data-testid="no-data-found"
    >
      <NoResultsIcon />
      <Typography variant="sectionTitle">{props.message}</Typography>
    </div>
  );
}
